export default {"src":"/_next/static/media/modern-map.391ec51a.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};